<template>
  <v-container fluid>
    <v-row>
      <slot></slot>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data: () => ({}),
  name: "ContainerSlot",
};
</script>
<style scoped></style>
